export class Pagination {
  pageNumber: number = 0;
  limit: number = 10;
  totalResults: number = 0;
  totalPages: number;

  constructor(pageNumber: number = 0, limit: number = 10, totalResults?: number) {
    this.pageNumber = pageNumber;
    this.limit = limit;
    if (totalResults) this.setTotalResults(totalResults);

  }

  setTotalResults(total) {
    this.totalResults = total;
    this._setTotalPages();
  }

  private _setTotalPages() {
    this.totalPages = Math.ceil(this.totalResults / this.limit);
  }

  // private _offset: number;
  get offset() {
    return this.pageNumber * this.limit;
  };

  /**
   * Displays the total number of results currently being show
   */
  get currentNumberShown(): number {
    return this.pageNumber + 1 < this.totalPages ? (this.pageNumber + 1) * this.limit : this.totalResults;
  }
}
